/*******************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 * Copyright 2022 Adobe
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 ******************************************************************************/

import styled from "styled-components";
import { AppHeaderHeight } from "components/shared/AppHeader";
import backdropImage from "images/home/tile.svg";
import { devices, fontFamilies } from "components/shared/Styles";
import illustration2x from "images/home-illustration@2x.png?responsive";
import dotBackdrop from "images/dot-backdrop.svg";

export const SplashCopy = styled.div`
  display: flex;
  flex-wrap: wrap;
  flex-direction: column;
  justify-content: center;
  font-size: 20px;
  max-width: min(546px, 60%);
  padding-bottom: 120px;
  position: relative;
  z-index: 1;

  ${devices.small} {
    align-items: center;
    margin-top: 0;
    text-align: left;
    max-width: none;
    padding-bottom: 116px;
  }
`;
export const SplashBackdrop = styled.div`
  position: relative;
  width: 100%;

  background-color: var(--spectrum-indigo-100);
  background-image: url(${backdropImage});
  background-position: center center;

  ${devices.large} {
    min-height: 592px;
  }
`;

export const HomeColumn = styled.div`
  max-width: 1156px;
  width: calc(100% - 208px);
  margin: auto;

  ${devices.small} {
    width: 100%;
  }
`;

export const Splash = styled.div`
  max-width: 1156px;
  width: calc(100% - 208px);
  margin: 0 auto;
  padding: ${AppHeaderHeight} 0 0 0;
  position: relative;
  color: #1a1a1a;
  display: flex;
  justify-content: center;

  ${devices.large} {
    flex-direction: column;
    min-height: 592px;
  }

  ${devices.small} {
    flex-direction: column-reverse;
    align-items: center;
    width: calc(100% - 48px);
    background-image: url(${backdropImage});
    background-color: #edeeff;
    padding: 24px;
    padding-top: 16px;
    margin-top: calc(${AppHeaderHeight} - 3px);
    background-repeat-y: no-repeat;
  }
`;

export const BottomSplash = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin-top: 128px;
  padding: 128px 24px;
  background-image: url("${dotBackdrop}");
  ${devices.small} {
    margin-top: 36px;
  }
`;

export const Title = styled.h1`
  font: normal normal 900 60px/66px ${fontFamilies};
  color: var(--spectrum-global-color-static-black);

  ${devices.small} {
    font-size: 42px;
    line-height: 48px;
  }
`;

export const Subtitle = styled.span`
  margin-top: 20px;
  font: normal normal normal 22px/27px ${fontFamilies};
  color: var(--spectrum-global-color-gray-900);

  ${devices.small} {
    margin-top: 16px;
  }
`;

export const SplashIllustration = styled.img.attrs({
  srcSet: illustration2x.srcSet,
  alt: "",
})`
  aspect-ratio: ${illustration2x.width / illustration2x.height};

  ${devices.large} {
    position: absolute;
    top: 50px;
    width: 865px;
    height: 528px;
    right: calc(-300px + min(0px, 100vw - 1400px) / 2);
  }

  ${devices.small} {
    width: 100%;
    min-width: 100vw;
    object-fit: contain;
    margin-left: 48px;
  }
`;
